import { defineModule } from '@/js/utils/helpers';

/**
 * The language dropdown opens independently of the menu: the trigger's chevron
 * flips, and an outside click or Escape dismisses it.
 */

let switches: HTMLElement[] = [];

const menuOf = (root: HTMLElement) =>
  root.querySelector<HTMLElement>('.ip-lang__menu');

const triggerOf = (root: HTMLElement) =>
  root.querySelector<HTMLElement>('.ip-lang__trigger');

const setOpen = (root: HTMLElement, open: boolean) => {
  const menu = menuOf(root);
  const trigger = triggerOf(root);
  if (!menu || !trigger) return;

  menu.hidden = !open;
  menu.classList.toggle('ip-drop-in', open);
  trigger.setAttribute('aria-expanded', String(open));
};

const closeAll = (except?: HTMLElement) =>
  switches.forEach((root) => root !== except && setOpen(root, false));

const onClick = (event: Event) => {
  const target = event.target as HTMLElement | null;
  const root = target?.closest<HTMLElement>('[data-language-switch]');

  if (!root) {
    closeAll();
    return;
  }

  if (!target?.closest('.ip-lang__trigger')) return;

  const menu = menuOf(root);
  closeAll(root);
  setOpen(root, Boolean(menu?.hidden));
};

const onKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape') closeAll();
};

export default defineModule(
  () => {
    switches = Array.from(
      document.querySelectorAll<HTMLElement>('[data-language-switch]'),
    );
    if (!switches.length) return;

    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKeydown);
  },
  () => {
    document.removeEventListener('click', onClick);
    document.removeEventListener('keydown', onKeydown);
    switches = [];
  },
);
